<template><span :class="{NOWRAP: pronounce && text.length < 100}">

<v-btn class="speaker_button" v-if="pronounce" @click="$nao.pronounce( kk(text) )" icon><v-icon> {{ $mdi.VolumeHigh }} </v-icon></v-btn>

<span v-for="(a,index) in arr" :class="nodecor ? undefined : $css.naoword">
	<span v-if="a[0] != '鰭'">{{a}}</span>
	<span v-else-if="a.slice(1) == '\n'" > <br> </span>
	<span v-else-if="no_popover" >{{ a.slice(1) }}</span>
	<span v-else class="nw" v-popover:naoword="{on_open: () => set_popover_text(index) }" >{{ a.slice(1) }}</span>
</span>
<span v-if="show_tr"> = 
	<span class="english_word">{{ $nao.tr_from_Nao(text).main_tr }}</span>
</span>

</span></template>

<script>
// v-popover:naoword="{on_open: () => make_popover(a.slice(1))}"
// <v-btn v-if="pronounce" @click="$nao.pronounce($nao.disassemble(text))" icon><v-icon> mdi-volume-high </v-icon></v-btn>

export default {
	components: {},
	props: {
		n: String,
		o: String,
		pronounce: Boolean,
		nodecor: Boolean,
		no_popover: Boolean,
		show_tr: Boolean,
		//is_text: Boolean
	},
	data() {
		return {
			
		}
	},
	computed: {
		text() {
			return  this.n ? this.$nao.unmake_neutral(this.n) : this.o;
		},
		arr() {
			let res = this.text.replace(/([\w']+|\n)/g, '🉇鰭$1🉇').split('🉇').filter(x => x.length > 0);
			//console.log(this.text.length);
			return res;
		}
	},
	created() {
		//console.log(this.n || this.o);
	},
	methods: {
		set_popover_text(index) {
			let word = this.arr[index];
			let tr = this.$nao.translate_sentence(word).map( w => this.$nao.tr_from_Nao(w) || {nao: w, main_tr: null } );

			this.$popover_naoword(tr);
		},
		kk() {
			let res = [];
			for (let w of this.$nao.translate_sentence(this.text) ) {
				res = res.concat( this.$nao.disassemble(w) );
			}
			return res;
		}
	}
}
</script>

<style scoped>

.nw:hover {
	color: red;
	cursor: pointer;
}

</style>